var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    rx: 12,
    fill: "#FF8989"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0156 19.8908L33.9262 20.8752L34.9105 19.8925C37.6586 17.2142 41.4648 15.9952 45.2055 16.6178C50.8574 17.5595 55 22.4502 55 28.1842V28.66C55 32.0643 53.5891 35.3209 51.0953 37.6424L36.2723 51.4811C35.657 52.0553 34.8449 52.3752 34 52.3752C33.1551 52.3752 32.343 52.0553 31.7277 51.4811L16.9039 37.6424C14.4134 35.3209 13 32.0643 13 28.66V28.1842C13 22.4502 17.1442 17.5595 22.7945 16.6178C26.4613 15.9952 30.3414 17.2142 33.0156 19.8908C33.0156 19.8917 32.9418 19.8908 33.0156 19.8908ZM33.9262 26.4451L30.2348 22.6061C28.4547 20.8982 25.9281 20.0877 23.4426 20.5011C19.6896 21.127 16.9375 24.3779 16.9375 28.1842V28.66C16.9375 30.9733 17.8981 33.1881 19.5904 34.7631L34 48.2162L48.4129 34.7631C50.1027 33.1881 51.0625 30.9733 51.0625 28.66V28.1842C51.0625 24.3779 48.3063 21.127 44.5574 20.5011C42.0719 20.0877 39.5453 20.8982 37.7652 22.6061L33.9262 26.4451Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heart-icon.2d364ba407d0e2ee340481a43a78c18e.svg";
export { ForwardRef as ReactComponent };